import { render } from "./Discard.vue?vue&type=template&id=7d237913"
import script from "./Discard.vue?vue&type=script&lang=js"
export * from "./Discard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__